import React from "react";
import "./PGAModelBuilderSection.css";

export default function PGAModelBuilderSection(props) {
  return (
    <div
      className={`pga-model-builder-section pga-model-builder-section-${props.widthType}`}
      {...props}
    >
      {props.children}
    </div>
  );
}
